import { reactive } from 'vue'
import { findRateCodeList,findContractCompanyList } from '@/api/room'
import { getAllBranchs,getAllStaffs }  from '@/api/branch'
import { getPeoples } from '@/api/people'
// import {} from ''

export default function commomFunction() {
    const rateCodeList = reactive([])
    const branchList = reactive([])
    const staffList = reactive([])
    const contractList = reactive([])
    const peopleList = reactive([])
    const findRateCodeAll = async () => {
        const { list } = await findRateCodeList({ page: 1, size: 1000, typehood: 2 })
        rateCodeList.length = 0
        rateCodeList.push(...(list || []))
    }
    const getAllBranchList = async () => {
        const res = await getAllBranchs({ })
        branchList.length = 0
        branchList.push(...(res || []))
    }
    const getAllStaffList = async () => {
        const res = await getAllStaffs({ })
        staffList.length = 0
        staffList.push(...(res || []))
    }
    const findContractCompanyLists = async () => {
        const { list } = await findContractCompanyList({page:1 ,size: 10000})
        contractList.length = 0
        contractList.push(...(list || []))
    }
    const findPeopleLists = async () => {
        const { list } = await getPeoples({page:1 ,size: 1000})
        peopleList.length = 0
        peopleList.push(...(list || []))
    }
    getAllBranchList()
    findRateCodeAll()
    getAllStaffList()
    findContractCompanyLists()

    return {
        branchList,
        rateCodeList,
        staffList,
        contractList
    }
}